import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=bd8c0442&"
import script from "./ProcessItem.vue?vue&type=script&lang=js&"
export * from "./ProcessItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=bd8c0442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports